import { useEffect, useState } from "react";
import ListVRF from "./ListVRF";
import { axios } from "../../../../../Global";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";

const VRFFinance = () => {
    const token = localStorage.getItem("token");
    const [vrfs, setVrfs] = useState();
    const [filteredVrfs, setFilteredVrfs] = useState();
    const [selectedStatus, setSelectedStatus] = useState("All");
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();


    const getVrf = async () => {
        setLoading(true);
        try {
            const result = await axios.get(`/dashboard/finance-visa-vrf`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setLoading(false);
            const data = result?.data?.data;
            setVrfs(data);
            if (selectedStatus == "All") {
                setFilteredVrfs(data)
            } else {
                const filteredData = data.filter(
                    (vrf) => vrf.finance_status === selectedStatus
                );
                setFilteredVrfs(filteredData);
            }

        } catch (error) {
            setLoading(false);
            dispatch(setAppError({ msg: `${error?.message}` }));
        }
    }


    useEffect(() => {
        getVrf();
    }, []);

    return (
        <div className="p-3 uppercase">
            <select className="  select select-sm select-bordered uppercase" value={selectedStatus} onChange={(e) => {
                const status = e.target.value;
                setSelectedStatus(status);

                if (status) {
                    const filteredData = vrfs.filter((vrf) => vrf.finance_status === status);
                    setFilteredVrfs(filteredData);
                } else {
                    setFilteredVrfs(vrfs);
                }
            }}>
                <option value="">All</option>
                <option value="Pending" >Pending</option>
                <option value="Completed">Completed</option>
            </select>
            <ListVRF
                vrfs={filteredVrfs}
                loading={loading}
                titles={[
                    "Sno",
                    "VRF No.",
                    "Sadad No.",
                    "Visa Provider name",
                    "Recruitment Agency",
                    "Finance Status",
                    "GR Requested Quantity",
                    "Actual Position",
                    "Country",
                    "VISA Profession",
                    "Available Quantity",
                    "Action"
                ]}
            />
        </div>
    )
}

export default VRFFinance;